import { MonitoringConfig } from '../services/monitoring';
import { LogLevel } from '../services/monitoring/loggingService';

function getEnvironmentValue(key: string, defaultValue?: string): string | undefined {
  return import.meta.env[key] || defaultValue;
}

function getBooleanEnvironmentValue(key: string, defaultValue: boolean = false): boolean {
  const value = import.meta.env[key];
  if (value === undefined) return defaultValue;
  return value.toLowerCase() === 'true';
}

export function createMonitoringConfig(): MonitoringConfig {
  const config: MonitoringConfig = {};

  // Performance monitoring configuration
  config.performance = {
    enableConsoleLogging: getBooleanEnvironmentValue('VITE_ENABLE_CONSOLE_LOGGING'),
    enableAnalytics: getBooleanEnvironmentValue('VITE_ENABLE_ANALYTICS', true),
  };

  // Analytics configuration
  config.analytics = {
    enableConsoleLogging: getBooleanEnvironmentValue('VITE_ENABLE_CONSOLE_LOGGING'),
    enableLocalStorage: true,
    batchSize: 50,
    flushInterval: 30000, // 30 seconds
    customEndpoint: getEnvironmentValue('VITE_ANALYTICS_URL'),
  };

  // Logging configuration
  config.logging = {
    level: import.meta.env.PROD ? LogLevel.WARN : LogLevel.DEBUG,
    enableConsole: getBooleanEnvironmentValue('VITE_ENABLE_CONSOLE_LOGGING', true),
    enableAnalytics: false, // Only log errors/warnings to analytics
    enableLocalStorage: true,
    maxLocalStorageEntries: 1000,
    enableRemoteLogging: !!getEnvironmentValue('VITE_LOGGING_ENDPOINT'),
    remoteEndpoint: getEnvironmentValue('VITE_LOGGING_ENDPOINT'),
  };

  return config;
}

// Export environment-specific configurations
export const isDevelopment = !import.meta.env.PROD;
export const isProduction = import.meta.env.PROD;

export const monitoringConfig = createMonitoringConfig();